export default __webpack_public_path__ + "static/media/forestly-expl-05_DE.369642cf.png";